import { throttle } from 'lodash';
import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixHero {
  static init(...parameters) {
    return new BrixHero(...parameters);
  }

  constructor(block) {
    if (block) {
      this.parallaxImage = block.querySelector('.-parallax-image');
      this.calculateAspectRatio(block);

      if (this.parallaxImage) {
        this.parallaxBackgroundImageOnScroll(block);
      }

      const backgroundVideoWrapper = document.querySelector(
        `#${block.id} > .background > .video`,
      );

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
  }

  calculateParallaxScrollValue(element, maxMovementInPixels) {
    const viewportHeight = window.innerHeight;
    const elementRect = element.getBoundingClientRect();
    const elementCenter = elementRect.top + elementRect.height / 2;
    const viewportCenter = viewportHeight / 2;
    const distanceFromCenter = elementCenter - viewportCenter;
    const parallaxScrollValue = distanceFromCenter * (maxMovementInPixels / viewportCenter);

    return parallaxScrollValue;
  }

  calculateMaxMovementInPixels(maxScaleValue, element) {
    const rect = element.getBoundingClientRect();
    const maxMovementInPixels = (rect.height * maxScaleValue - rect.height) / 2;
    return maxMovementInPixels;
  }


  parallaxBackgroundImageOnScroll() {
    const { parallaxImage } = this;

    if (parallaxImage) {
      document.addEventListener('DOMContentLoaded', () => {
        const maxScaleValue = 1.1;
        const maxMovementInPixels = this.calculateMaxMovementInPixels(maxScaleValue, parallaxImage);
        parallaxImage.style.transform = `scale(${maxScaleValue})`;

        window.addEventListener('scroll', throttle(() => {
          const scrollValue = this.calculateParallaxScrollValue(parallaxImage, maxMovementInPixels);

          // Clamp translate value within a specified range
          const minTransform = -maxMovementInPixels; // Minimum translate value
          const maxTransform = maxMovementInPixels; // Maximum translate value
          const transformValue = Math.min(Math.max(scrollValue, minTransform), maxTransform);

          parallaxImage.style.transform = `translate3d(0, ${transformValue}px, 0px) scale(${maxScaleValue})`;
        }), 1, { passive: true });
      });
    }
  }

  calculateAspectRatio(block) {
    const image = block.querySelector('.image');

    if (image) {
      const { aspectRatio } = image.dataset;
      if (aspectRatio) {
        image.style.aspectRatio = aspectRatio;
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero', BrixHero.init);
}
